import React, { useState } from "react";
// import TextInput from "../../../components/TextInput";
// import SectionHeading from "../../../components/SectionHeading";
import PropTypes from "prop-types";
import { CONSTANTS as C } from "config";
import GoogleMap from "components/GoogleMap";
import { useTranslation } from "react-i18next";
import AppCollapse from "components/ui/AppCollapse.jsx";
import AppInput from "components/ui/AppInput.jsx";

const StoreMapSection = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <div className="w-full mb-3">
      <AppCollapse
        defaultOpen={props.defaultOpen ?? false}
        title={t("Store Location")}
        subtitle={t(
          "Enter your full address below, then search or move the map to pin your store."
        )}
      >
        <div className="flex flex-col gap-5">
          <AppInput
            label={t("Complete Address")}
            type="text"
            placeholder={t("Store Complete Address")}
            mandatory={true}
            value={props.store?.values?.[C.KEY_MANUAL_ADDRESS] ?? ""}
            onChange={(e) =>
              props.handleValues(C.KEY_MANUAL_ADDRESS, e.target.value)
            }
            error={props.store?.errors?.[C.KEY_MANUAL_ADDRESS]}
          />
          <GoogleMap
            label="Enter Google Map Location"
            placeholder={t("Location")}
            handleValues={props.handleValues}
            width={"100%"}
            height={"420px"}
            state={props.store}
            setState={props.setStore}
            setLoading={setLoading}
            zoom={props.zoom}
          />
        </div>
        {/* <AppInput label="Domain" type="text" placeholder="Domain"/>
        <AppInput label="Store Link" type="text" placeholder="www.resthero.com">
            <AppButton>Copy link</AppButton>
        </AppInput> */}
        
    </AppCollapse>
    </div>
    // <React.Fragment>
    //   <Spin spinning={loading}>
    //     <div
    //       className="bg-white"
    //       style={{ height: "80vh", display: "flex", flexDirection: "column" }}
    //     >
    //       <SectionHeading title={t("Store Location")} />
    //       <div className="px-2 md:px-6 py-4">
    //         <TextInput
    //           label={t("Enter Complete Address")}
    //           mandatory={true}
    //           value={props.store.values[C.KEY_MANUAL_ADDRESS]}
    //           handleValues={props.handleValues}
    //           keyVal={C.KEY_MANUAL_ADDRESS}
    //           error={props.store.errors[C.KEY_MANUAL_ADDRESS]}
    //         />
    //       </div>
    //       <div className="w-full relative">
    //         <GoogleMap
    //           handleValues={props.handleValues}
    //           width={"90%"}
    //           height={"450px"}
    //           state={props.store}
    //           setState={props.setStore}
    //           setLoading={setLoading}
    //           zoom={props.zoom}
    //         />
    //       </div>
    //     </div>
    //     <div className="w-full text-center mb-4 mt-4">
    //       {props.type === "create" ? (
    //         <Button
    //           type="primary"
    //           size="large"
    //           className="w-36"
    //           onClick={handleSubmit}
    //         >
    //           {t("Next")}
    //         </Button>
    //       ) : null}
    //     </div>
    //   </Spin>
    // </React.Fragment>
  );
};
StoreMapSection.propTypes = {
  store: PropTypes.object,
  handleValues: PropTypes.func,
  defaultOpen: PropTypes.bool,
};
export default StoreMapSection;
